import Input from "../../Input"

const DateChannel = ({ index, values, serverData }) => {
    return (
        <div className="mx-14 h-full">
            <h6 className="flex justify-center">چنل تاریخ {index + 1}</h6>
            <div className="font-sans">
                <Input
                    type="number"
                    name={`dateChannels-${index}-id`}
                    label="ایدی چنل *"
                    placeholder="ChannelID"
                    autoComplete="off"
                    options={serverData?.channelList}
                    defaultValue={values?.id}
                    dir="ltr"
                />
            </div>
            <div className="mt-2">
                <Input
                    type="text"
                    label="فرمت *"
                    name={`dateChannels-${index}-format`}
                    placeholder="format"
                    autoComplete="off"
                    defaultValue={values?.format}
                    dir="ltr"
                />
            </div>
            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>متغیرها:</span>
                <div dir="ltr" className="grid grid-rows-5 grid-cols-2">
                    <div>%YYYY: سال میلادی</div>
                    <div>%yyyy: سال شمسی</div>
                    <div>%YY: دو رقم اخر سال میلادی</div>
                    <div>%yy: دو رقم اخر سال شمسی</div>
                    <div>%MM: ماه به میلادی</div>
                    <div>%mm: ماه به شمسی</div>
                    <div>%DD: روز به میلادی</div>
                    <div>%dd: روز به شمسی</div>
                    <div>%month: ماه در سال به میلادی</div>
                    <div>%mah: ماه در سال به شمسی</div>
                    <div>%day: روز در هفته به میلادی</div>
                    <div>%rooz: روز در هفته به شمسی</div>
                </div>
            </div>
        </div>
    )
}

export default DateChannel
